import { render } from "./HorseEditOffspringView.vue?vue&type=template&id=6352d884&scoped=true"
import script from "./HorseEditOffspringView.vue?vue&type=script&lang=js"
export * from "./HorseEditOffspringView.vue?vue&type=script&lang=js"

import "./HorseEditOffspringView.vue?vue&type=style&index=0&id=6352d884&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6352d884"]])

export default __exports__